<template>
  <v-app>
    <div class="login-container">
      <app-updated-alert :auth="!isMasterLogin" :auth-like="isMasterLogin" />
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
    <vue-snotify />
  </v-app>
</template>

<script>
import { LAYOUT_AUTH } from "Shared/store/ui";
import AppUpdatedAlert from "Public/components/GlobalModals/AppUpdatedAlert";
import { appRoutes } from "Public/consts/appRoutes";

export default {
  name: LAYOUT_AUTH,
  components: { AppUpdatedAlert },
  computed: {
    isMasterLogin() {
      return this.$route.path === appRoutes.masterLogin;
    },
  },
};
</script>
